import { useEffect, useState } from 'react'
import { GetTiposRecurso } from '../services/ConfiguracionRecursos.service'

export interface TipoRecursoOption {
  label: string
  value: number
}

const useTiposRecurso = () => {
  const [options, setOptions] = useState<TipoRecursoOption[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    GetTiposRecurso()
      .then((response: any) => {
        const tipos = response.data?.body ?? response.data?.data ?? response.data ?? []
        setOptions(
          (tipos ?? []).map((t: any) => ({
            value: t.id,
            label: t.nombre,
          }))
        )
      })
      .catch(() => setOptions([]))
      .finally(() => setLoading(false))
  }, [])

  return { options, loading }
}

export default useTiposRecurso